import * as React from 'react';
import styled from 'styled-components';


interface InputProps {
  type?: 'text' | 'password' | 'search' | undefined;
  placeholder?: string | undefined;
  disabled?: boolean;
  onFocus?: VoidFunction | undefined;
  onBlur?: VoidFunction | undefined;
}

const InputStyle = ({ type = 'text', disabled = false, onFocus, onBlur, ...props}: InputProps) => (
  <Input type={type} disabled={disabled} onFocus={e => handleFocus(e, onFocus)} onBlur={e => handleFocusOut(e, onBlur)} {...props} />
)

const handleFocus = (e:any, callback:VoidFunction | undefined) => {
  e.target.parentNode.classList.add('focus');
  callback && callback();
}

const handleFocusOut = (e:any, callback:VoidFunction | undefined) => {
  e.target.parentNode.classList.remove('focus');
  callback && callback();
}


export default InputStyle;


const Input = styled.input`
  border: 0 none;

  &:focus {
    color: #9b8a70;
  }
`;


// WEBPACK FOOTER //
// ./src/styles/ui/Input.tsx